// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 自定义弹框样式 */
[data-v-91f8ec7a] .van-dialog {
  border-radius: 16px;
  overflow: hidden;
}
[data-v-91f8ec7a] .van-dialog__header {
  padding: 0;
}
[data-v-91f8ec7a] .van-dialog__content {
  padding: 0;
}
[data-v-91f8ec7a] .van-dialog__close {
  top: 16px;
  right: 16px;
  color: #999;
  font-size: 20px;
}

/* .common-dialog {
  max-width: 340px;
  width: 90%;
} */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
